import * as React from "react";
import * as classNames from "classnames";

export interface TextProps {}

class TextArea extends React.PureComponent<any, any> {
  render() {
    return (
      <textarea
        className={this.props.className}
        name={this.props.name}
        id={this.props.id}
        rows={this.props.rows}
        onBlur={this.props.onBlur}
        onChange={this.props.onChange}
        onFocus={this.props.onFocus}
        onKeyPress={this.props.onKeyPress}
        placeholder={this.props.placeholder}
        value={this.props.value}
        disabled={this.props.disabled}
        maxLength={this.props.maxLength}
        autoComplete={this.props.autoComplete}
      />
    );
  }
}

export default TextArea;



// WEBPACK FOOTER //
// ./src/components/Controls/TextArea.tsx